import { render, staticRenderFns } from "./Account_RegisterForm.vue?vue&type=template&id=37e5e2ba&scoped=true&"
import script from "./Account_RegisterForm.vue?vue&type=script&lang=js&"
export * from "./Account_RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./Account_RegisterForm.vue?vue&type=style&index=0&id=37e5e2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5e2ba",
  null
  
)

export default component.exports